import type { YardAccessDenial } from "@etudescarre/constants";
import { isNotNil } from "@etudescarre/utils";

// Shown in a toast, never on a page of its own.
export const YARD_ACCESS_DENIED_TITLE = "Chantier inaccessible";

const DENIAL_MESSAGES: Record<YardAccessDenial, string> = {
  yard_not_commissioned:
    "Ce chantier n'est pas encore mis en service : il s'ouvrira à sa mise en service.",
  yard_off:
    "Ce chantier est interrompu (OFF) : son accès est suspendu jusqu'à sa remise en service.",
  account_inactive:
    "Votre compte est désactivé : contactez votre correspondant ChantierCarré.",
  not_on_yard: "Vous n'êtes rattaché à aucun contrat actif de ce chantier.",
};

const STAFF_NOT_ON_YARD =
  "Votre compte ChantierCarré n'est rattaché à aucun contrat de ce chantier. Pour le voir comme l'un de ses utilisateurs, incarnez-le depuis l'accueil staff.";

export const YARD_CLOSED_MESSAGE =
  "Ce chantier est clôturé : il n'est plus accessible.";

const YARD_NOT_FOUND_MESSAGE = "Ce chantier n'existe pas.";

const YARD_LOAD_FAILED_MESSAGE =
  "Le chantier n'a pas pu être chargé. Réessayez dans un instant.";

const isYardAccessDenial = (code: string): code is YardAccessDenial =>
  Object.hasOwn(DENIAL_MESSAGES, code);

/** Why this account cannot open the yard. */
export function yardAccessMessage(denial: YardAccessDenial): string {
  return DENIAL_MESSAGES[denial];
}

/**
 * Why the yard context request failed, from its HTTP status and error code.
 * `staff` is a ChantierCarré account using its own session (not impersonating).
 */
export function yardOpenFailureMessage(
  status: number,
  code: string | undefined,
  staff: boolean,
): string {
  if (status === 404) return YARD_NOT_FOUND_MESSAGE;
  if (code === "not_on_yard" && staff) return STAFF_NOT_ON_YARD;
  if (isNotNil(code) && isYardAccessDenial(code)) return DENIAL_MESSAGES[code];
  return YARD_LOAD_FAILED_MESSAGE;
}
